module.exports = __webpack_public_path__ + "72dec37a.svg";